import UserDB from '@/firebase/users-db';

export default {
    updateState: async({ commit, rootState }, payload) => {
        const userDb = new UserDB(rootState.user.currentUser.uid);
        commit('setProductCreationPending', true);

        await userDb.updateInside(
            payload.selectedContent,
            payload.path,
            payload.userId,
        );
        commit('user/SET_STATE', payload.selectedContent, { root: true });
        commit('setProductCreationPending', false);
    },

    triggerState: ({ dispatch }, payload) => {
        dispatch('updateState', payload);
    },
}